import { WidgetBase } from '../../../_common/platform/ts/WidgetBase';
import { UsersWidget as mainModule } from './main';
import * as $ from 'jquery';

declare var require: any;
require('../sass-main/pdc-widget-users.sass');

export class UsersWidget extends WidgetBase {
    public static _name: string = 'Users';
    public static group = 'Administrative';
    public static moduleName: string = 'pdc-widget-users';
    public static icon: string = 'user';

    public static load() {
        var def = $.Deferred();

        require.ensure(
            ['./main'],
            (require) => {
                var module: typeof mainModule = require('./main');

                def.resolve(module);
            },
            'pdc-widget-users'
        );

        return def;
    }

    constructor(
        values: { [fieldName: string]: any },
        locked: { [fieldName: string]: any },
        ignoreValidation?: boolean,
        glob: any = {}
    ) {
        super(values, locked, ignoreValidation, glob);
    }
}

WidgetBase.register(UsersWidget);
